import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const TurmaComboBox = ({ turmas, turma, handleTurmaChange }) => {
    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl required fullWidth >
                <InputLabel id="turma-label">Turma</InputLabel>
                <Select
                    labelId="turma-label"
                    id="turma-select"
                    value={turma ? turma.codigo : ''}
                    onChange={handleTurmaChange}
                >
                    {turmas.map(t => (
                        <MenuItem key={t.codigo} value={t.codigo}>{t.descricao} ({t.curso.abreviacao})</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}

export default TurmaComboBox;